import React from "react";
import ConversationSummary from "../../components/ConversationSummary";
import CopyLink from "../../components/CopyLink";
import ConversationFollowUp from "../../components/ConversationFollowUp";

const MessageDetails = ({ selectedThread }) => {
  const getCountryIcon = twoLetterCountryCode => {
    if (!twoLetterCountryCode) {
      return <div className="w-6 h-6 bg-gray-200 rounded-full"></div>;
    }

    const flagUrl = `https://flagcdn.com/w40/${twoLetterCountryCode.toLocaleLowerCase()}.png`;

    return (
      <img
        src={flagUrl}
        alt={`${twoLetterCountryCode} flag`}
        className="w-6 h-6 rounded-full object-cover"
      />
    );
  };

  const customer = selectedThread.customer;

  const customerData = customer
    ? {
        location: customer.country
          ? `${customer.city}, ${customer.state}, ${customer.country}`
          : "Unknown location",
        name: customer.first_name
          ? `${customer.first_name} ${customer.last_name}`
          : "Unknown Name",
        email: customer.email,
        url: customer.url,
        phone: customer.phone,
      }
    : {};

  return (
    <div className="bg-white p-4 hidden xl:block">
      {selectedThread && (
        <div className="w-full p-4 bg-white rounded-lg">
          <div>
            <p className="text-xs font-semibold text-gray-500">Name</p>
            <h2 className="text-lg font-bold text-gray-600">
              {customerData.name}
            </h2>
          </div>
          <div className="mt-4">
            <p className="text-xs font-semibold text-gray-500">Location</p>
            <div className="flex items-center space-x-2">
              <span>{getCountryIcon(selectedThread.twoLetterCountryCode)}</span>
              <p className="text-sm text-gray-700 m-0">
                {customerData.location}
              </p>
            </div>
          </div>
          <div className="mt-4">
            <p className="text-xs font-semibold text-gray-500">Current URL</p>
            {customerData.url ? (
              <CopyLink url={customerData.url} />
            ) : (
              "Not available"
            )}
          </div>
          <div className="mt-4">
            <p className="text-xs font-semibold text-gray-500">Email</p>
            {customerData.email ? (
              <CopyLink url={customerData.email} />
            ) : (
              "Not available"
            )}
          </div>

          <div className="mt-4">
            <p className="text-xs font-semibold text-gray-500">Phone</p>
            {customerData.phone ? (
              <CopyLink url={customerData.phone} />
            ) : (
              "Not available"
            )}
          </div>

          <div className="mt-4">
            <p className="text-xs font-semibold text-gray-500">
              Summary of Conversation
            </p>
            <p className="text-sm text-gray-700 mt-1">
              <ConversationSummary
                conversation={selectedThread}
                hideTitle={true}
              />
            </p>
          </div>

          <div className="mt-4">
            <p className="text-xs font-semibold text-gray-500">
              Follow-up Action
            </p>
            <p className="text-sm text-gray-700 mt-1">
              <ConversationFollowUp
                conversation={selectedThread}
                hideTitle={true}
              />
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageDetails;
